import React from 'react';
import { 
  Clock
} from 'lucide-react';
import SLAPolicyManagement from './SLAPolicyManagement';

const UnifiedSLAManagement = () => {
  return (
    <div className="py-6 space-y-6">
      {/* Header */}
      {/* <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
              <Clock className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">SLA Management</h1>
              <p className="text-gray-600 dark:text-gray-400 mt-1">
                Comprehensive SLA management and monitoring
              </p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Policy Management Content */}
      <SLAPolicyManagement />
    </div>
  );
};

export default UnifiedSLAManagement;
